import { FuelInteractiveIcon, FuelTypography } from '@frete.com/fuel-react';
import { FC } from 'react';

import { Container } from './styled';
import { HeaderProps } from './types';

export const Header: FC<HeaderProps> = ({ title, action, actionIcon = 'arrow-left' }) => (
  <Container $hasAction={!!action}>
    {!!action && <FuelInteractiveIcon onClick={action} size="large" icon={actionIcon} />}
    <FuelTypography weight="bold" size="heading-md" color="neutral-strong">
      {title}
    </FuelTypography>
  </Container>
);
